

import React                  from 'react';
import ReactDOM               from 'react-dom';
import GroupLicensePopover    from '_views/shared/GroupLicensePopover';

const groupLicensePopover = {

  render: function (opts) {

    const mountPoint = document.querySelector(opts.selector);

    
    /*
    ==================================================
     MOUNT REACT COMPONENT
    ==================================================
    */

    if (mountPoint) {
      ReactDOM.render( <GroupLicensePopover />, mountPoint );
    }
  },
}

export default groupLicensePopover;
